export default "__VITE_ASSET__D6v$bDt___"